import { gestureObjV2, multiGesture } from "@/gestureRow.js";

/**
 * 正在组合键输入中
 * @param {*} targetKey 目标按键
 * @param {*} realKey 实际按键
 * @returns
 */
export const isShiftInputing = (targetKey, realKey) => {
  if (
    multiGesture.includes(targetKey) &&
    gestureObjV2[targetKey].keys.includes(realKey) &&
    realKey !== targetKey
  ) {
    return true;
  }
  return false;
};

export const isInputRight = (targetKey, realKey) => {
  return targetKey === realKey || (targetKey === "↵" && realKey === "{enter}");
};

export const chineseToEnglishMap = {
  "·": "`",
  "～": "~",
  "！": "!",
  "＠": "@",
  "＃": "#",
  "¥": "$",
  "％": "%",
  "…": "^",
  "……": "^",
  "＆": "&",
  "＊": "*",
  "（": "(",
  "）": ")",
  "——": "_",
  "—": "_",
  "＿": "_",
  // "＋": "+",
  // "＝": "=",
  "「": "{",
  "」": "}",
  "【": "[",
  "】": "]",
  "｜": "|",
  "、": "\\",
  "：": ":",
  "；": ";",
  "‘": "'",
  "’": "'",
  "“": '"',
  "”": '"',
  "，": ",",
  "。": ".",
  "《": "<",
  "》": ">",
  "／": "/",
  "？": "?",
  空格: " ",
  // 其他需要映射的中文字符
};
